import * as tslib_1 from "tslib";
import * as account from '../actions/account';
var initialState = {
    verifyEmailWorking: false,
    verifyEmailSuccess: false,
    verifyEmailError: null,
    accountValidationResult: null
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case account.USER_VERIFY_EMAIL:
            return tslib_1.__assign({}, state, { verifyEmailWorking: true, verifyEmailError: null });
        case account.USER_VERIFY_EMAIL_SUCCESS:
            return tslib_1.__assign({}, state, { verifyEmailWorking: false, verifyEmailSuccess: true, accountValidationResult: action.payload });
        case account.USER_VERIFY_EMAIL_FAILED:
            return tslib_1.__assign({}, state, { verifyEmailWorking: false, verifyEmailSuccess: false, verifyEmailError: action.payload });
        default:
            return state;
    }
}
export var isVerifyEmailWorking = function (state) { return state && state.verifyEmailWorking; };
export var isVerifyEmailSuccess = function (state) { return state && state.verifyEmailSuccess; };
export var getVerifyEmailError = function (state) { return state && state.verifyEmailError; };
export var getAccountValidationResult = function (state) { return state && state.accountValidationResult; };
